<template>
  <div class="langue-switch">
    <div @click="setLanguage('fr')" v-if="langue === 'en'" :style="{ backgroundImage: `url('interface/fr-flag.png')` }"></div>
    <div @click="setLanguage('en')" v-if="langue === 'fr'" :style="{ backgroundImage: `url('interface/en-flag.png')` }"></div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'langueSwitch',
  props: {
    langue: String
  },
  computed: {
    ...mapState(['storeUrlArray']),
    imagePath() {
      // Utilise BASE_URL qui est défini dans vue.config.js
      return process.env.BASE_URL || '/';
    }
  },
  mounted() {
    console.log('BASE_URL:', process.env.BASE_URL); // Debug
    console.log('VUE_APP_IMAGES_BASE:', process.env.VUE_APP_IMAGES_BASE); // Debug
    
    if (this.storeUrlArray.langue !== undefined) {
      this.setLanguage(this.storeUrlArray.langue);
    }
  },
  methods: {
    ...mapActions(['updateStateValue']),
    setLanguage(language) {
      this.updateStateValue({ key: 'storeUrlArray', value: { ...this.storeUrlArray, langue: language } });
    }
  }
};
</script>

<style scoped>
.langue-switch {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}

.langue-switch div {
  border: none;
  border-radius: 20px;
  cursor: pointer;
  background-size: cover;
  background-position: center;
  height: 100%;
  width: 100%;
}
</style>